module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form"
  }, [_c('el-dialog', {
    attrs: {
      "title": _vm.title,
      "visible": _vm.AddDialogVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.AddDialogVisible = $event
      }
    }
  }, [_c('el-form', [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.classList,
      "highlight-current-row": "",
      "element-loading-text": "拼命加载中",
      "border": ""
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "年段",
      "prop": "GradeName"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "班级名称",
      "prop": "ClassName"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "设备绑定码",
      "prop": "DeviceBindCode"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "网络检测情况",
      "prop": "StatusName"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "是否为下单班级",
      "prop": "IsOrderClass"
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "footer"
  }, [_c('el-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-button', {
    on: {
      "click": _vm.close
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("确定")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-38136f08!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Network/networkCheck/components/classListDialog/index.vue
// module id = 1454
// module chunks = 1